import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type {
  IFormDataResponse,
  IGeneralData,
  IPlantillaHC
} from '@/modules/PlantillasHC/interfaces'

export class PlantillasHCService extends BaseService<IPlantillaHC> {
  constructor () {
    super({
      baseUrl: 'scheduling/hc-templates/'
    })
  }

  async generales (params?: Record<string, unknown>): Promise<AxiosResponse<IResponseApi<IGeneralData[]>>> {
    return this.http.get<IResponseApi<IGeneralData[]>>('/general', { params })
  }

  async getFormData (id: number): Promise<AxiosResponse<IResponseApi<IFormDataResponse>>> {
    return this.http.get<IResponseApi<IFormDataResponse>>(`/form-data/${id}`)
  }

  async forFormulario (codoId: number): Promise<AxiosResponse<IResponseApi<IPlantillaHC[]>>> {
    return this.http.get<IResponseApi<IPlantillaHC[]>>(`/for-formulario/${codoId}`)
  }

  async getLimite (): Promise<AxiosResponse<IResponseApi<{ total: number; limite: number }>>> {
    return this.http.get<IResponseApi<{ total: number; limite: number }>>('/limite')
  }
}

export const plantillasHCService = new PlantillasHCService()
